import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { Components, Logger, Types } from "@sendum/core";

import { VisibilityRootState } from "../store/VisibilityStore";

import classes from "./VisibilityMap.module.scss";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const logger = new Logger("VisibilityMap");

interface IProps {
	className?: string;
}

export const VisibilityMap = (props: IProps): JSX.Element => {
	logger.debug("render");
	const device = useSelector((state: VisibilityRootState) => state.Visibility.device);
	const present = useSelector((state: VisibilityRootState) => state.Visibility.present);
	const points = useSelector((state: VisibilityRootState) => state.Visibility.points);
	const historyLoading = useSelector((state: VisibilityRootState) => state.Visibility.historyLoading);
	const isLoading = useMemo<boolean | undefined>(() => historyLoading.get(`${device?.id || ""}#${device?.shipment.id || ""}#location`), [historyLoading, device]);
	const location = useMemo<Types.TLocationProperty>(() => present?.location, [present]);

	logger.debug(present, location);

	return (
		<Components.Map
			className={classNames(props.className, classes.map)}
			device={device}
			pins={points}
			isHistoryPins={true}
			isLoading={isLoading}
			location={location}
		/>
	);
};
